// ./src/components/features/EventTeamsInfoBadge/EventTeamsInfoBadge.tsx
import React from "react";
import { Text } from "@mantine/core";

export interface EventTeamsInfoBadgeProps {
  event: any | null | undefined;
}

export const EventTeamsInfoBadge: React.FC<EventTeamsInfoBadgeProps> = ({
  event,
}) => {
  if (!event) {
    return null;
  }

  let teams = [];

  if (Array.isArray(event.eventTeams)) {
    teams = event.eventTeams;
  } else if (Array.isArray(event.recurringEventTeams)) {
    teams = event.recurringEventTeams;
  }

  const teamsNames = teams.map((team: any) => team.teamName).join(", ");

  return <Text>{teamsNames}</Text>;
};
